module.exports = __webpack_public_path__ + "static/floor-ce30edca3602f9d21fa687ff7252687c.jpg";